import { useEffect } from "react";
import Footer from "../components/footer"

import logo from "../assets/24logo.png"
import appstore from "../assets/appstore.png"

export default function Start() {

    useEffect(() => {
        document.title = 'Compete';
      }, []);

    return (
        <div>
            <div className="section">
                <div className="container start">
                    <img src={logo} />
                    <h1>Now available on the App Store</h1>
                    <img src={appstore} className="appstore" />
                </div>
            </div>
            <Footer />
        </div>
    )
}